<template>
  <ModeSelector />
  <router-view />
</template>

<script setup lang="ts">
import ModeSelector from '@/components/ModeSelector.vue';
import { setupFreshchat, type IFreshchatConfig } from '@/utils/freshchat.utils';
import { createException } from '@/utils/monitoring.utils';
import { onMounted } from 'vue';

onMounted(() => {
  const config: IFreshchatConfig = {
    token: 'a142ad56-f318-45ac-960d-da9b316f5c09',
    host: 'https://wchat.freshchat.com',
    siteId: 'Customer',
  };

  setupFreshchat(config).catch((error) => {
    if (error instanceof Error) {
      createException(error);
    } else {
      createException(new Error('Failed to load Freshchat script'), {
        extra: {
          error,
        },
      });
    }
  });
});
</script>
